import xxhash from 'xxhash-wasm';

import { base48encode } from './base48';

const DEFAULT_HASH_LENGTH = 10;
const MIN_HASH_LENGTH = 7;
const MAX_HASH_LENGTH = 12;

const hasherReady = xxhash();

// Cached resolved hasher — set once when the WASM module loads.
let syncHasher: Awaited<typeof hasherReady> | null = null;
void hasherReady.then((h) => {
	syncHasher = h;
	return h;
});

// Mirror of the lambda's `calculateHash` (longlinks_shortener/api/store.js).
// Algorithm: xxh64(utf8(longUrl), seed=0) → uint64 BigInt → base48 (low N digits).
export async function generateShareId(longUrl: string, hashLength: number = DEFAULT_HASH_LENGTH): Promise<string> {
	if (!Number.isFinite(hashLength) || hashLength < MIN_HASH_LENGTH || hashLength > MAX_HASH_LENGTH) {
		throw new Error(`'hashLength' must be in the range [${MIN_HASH_LENGTH}, ${MAX_HASH_LENGTH}]`);
	}
	const hasher = await hasherReady;
	return base48encode(hasher.h64(longUrl), hashLength);
}

// Synchronous variant — returns null if the WASM hasher isn't loaded yet.
// Safe to call during render; once the module is initialised the value is stable.
export function generateShareIdSync(longUrl: string, hashLength: number = DEFAULT_HASH_LENGTH): string | null {
	if (!syncHasher) return null;
	if (!Number.isFinite(hashLength) || hashLength < MIN_HASH_LENGTH || hashLength > MAX_HASH_LENGTH) {
		throw new Error(`'hashLength' must be in the range [${MIN_HASH_LENGTH}, ${MAX_HASH_LENGTH}]`);
	}
	return base48encode(syncHasher.h64(longUrl), hashLength);
}
